export default __webpack_public_path__ + "static/media/logo.7b4a339d.png";